import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Container,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

//helpers
import {
  formateDateApi,
  formateDateandTime,
} from "../../../helpers/formats.js";
import { ValidaEmail } from "../../../helpers/email";
import {
  onlyAlphaNumericAndSpace,
  onlyNumber,
} from "../../../helpers/valid.js";
import { isValidDate } from "../../../helpers/valid.js";

// services
import {
  InputCEP,
  InputCNPJ,
  InputCPF,
  InputTELEFONE,
} from "../../../services/mask.js";
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";
import {
  EnviaProtocoloWithProtocoloTransportador,
  EnviaRequerimentoTransportador,
} from "../../../services/protocolo_transportador_service.js";
import { GetCEPViaCEP } from "../../../services/viaCep";

//Context
import { useAuth } from "../../../context/auth";

export default function Identificacao({
  item,
  tipoCadastro,
  permiteManutencao,
  handleProximoStep,
  handleReturn,
}) {
  const { session, setLoading } = useAuth();

  const { register, handleSubmit, errors, setError, setValue, clearErrors } =
    useForm({ mode: "onBlur" });

  const [permiteEditar, set_permiteEditar] = useState(true);
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);

  const [identificacao, set_identificacao] = useState(null);

  // Status
  const [status, set_status] = useState("");
  const [options_status] = useState([
    { value: "Ativo", label: "Ativo" },
    { value: "Cancelado", label: "Cancelado" },
    { value: "Inativo", label: "Inativo" },
    { value: "Pendente", label: "Pendente" },
    { value: "Vencido", label: "Vencido" },
    ...(item?.setupSolicitacaoAcaoNovoCadastro?.setupSolicitacao?.categoria
      .segmento == "Transportador" &&
      item?.setupSolicitacaoAcaoNovoCadastro?.setupSolicitacao.categoria.sigla ==
      "RGG"
      ? [{ value: "Irregular", label: "Irregular" }]
      : []),
  ]);
  const handleStatus = (value) => {
    set_status(value);
    setValue("status", value, true);
    clearErrors("status");
  };

  // E-Mail
  const [email, set_email] = useState("");
  const handleEmail = (event) => {
    if (event.target.value.length == 0) return;

    set_email(event.target.value);

    ValidaEmail(event.target.value, handleRetornoValidaEmail);
  };
  const handleRetornoValidaEmail = (result) => {
    if (!result.data) {
      showMessage("Aviso", "E-Mail inválido.", "error", null);
      setValue("email", "");
      set_email("");
    }
  };

  // Nome Fantasia
  const handleFantasia = (event) => {
    let result = onlyAlphaNumericAndSpace(event.target.value);
    setValue("fantasia", result);
  };

  // Razão Social
  const handleRazaoSocial = (event) => {
    let result = onlyAlphaNumericAndSpace(event.target.value);
    setValue("razaoSocial", result);
  };

  // Nome do Solicitante
  const handleSolicitante = (event) => {
    let result = onlyAlphaNumericAndSpace(event.target.value);
    setValue("nomeSolicitante", result);
  };

  // Data Vigência
  const handleDataVigencia = (event) => {
    let input_date = event.target.value;

    if (input_date != "" || input_date.length > 0) {
      if (isValidDate(input_date) == false) {
        showMessage("Aviso", "Data de validade inválida.", "warning", null);
        return;
      }
    }
  };

  const [optionsTipoTransportador, set_OptionsTipoTransportador] = useState([
    { value: "Pessoa Física / MEI", label: "Pessoa Física / MEI" },
    { value: "Pessoa Jurídica / MEI", label: "Pessoa Jurídica (MEI)" },
    { value: "Pessoa Jurídica (Privado)", label: "Pessoa Jurídica (Privado)" },
    { value: "Pessoa Jurídica (Público)", label: "Pessoa Jurídica (Público)" },
  ]);
  const [tipoTransportador, set_tipoTransportador] = useState(
    "Pessoa Jurídica (Privado)"
  );
  const handleTipoTransportador = (value) => {
    set_tipoTransportador(value.value);
    setValue("tipoTransportador", value.value, true);
    clearErrors("tipoTransportador");
  };

  //SubPrefeitura
  const [optionsSubPrefeitura, set_OptionsSubPrefeitura] = useState([]);
  const [subPrefeitura, set_subPrefeitura] = useState(null);
  const loadOptionsSubPrefeitura = () => {
    api_GET("subprefeitura")
      .then((result) => {
        set_OptionsSubPrefeitura(result.data);
        if (tipoCadastro == "Protocolo") {
          if (item != null && item.protocoloTransportador.length > 0) {
            set_subPrefeitura(item.protocoloTransportador[0].subPrefeitura);
            setValue(
              "subPrefeitura",
              item.protocoloTransportador[0].subPrefeitura,
              true
            );
          }
        } else if (tipoCadastro == "Requerimento") {
          if (item != null && item.requerimentoTransportador.length > 0) {
            set_subPrefeitura(item.requerimentoTransportador[0].subPrefeitura);
            setValue(
              "subPrefeitura",
              item.requerimentoTransportador[0].subPrefeitura,
              true
            );
          }
        }
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };
  const handleSubPrefeitura = (value) => {
    set_subPrefeitura(value);
    setValue("subPrefeitura", value, true);
    clearErrors("subPrefeitura");
  };

  const [tipoIndustria, set_tipoIndustria] = useState("");
  const [ramo, set_ramo] = useState("");
  // Número Endereço
  const handleNumeroEndereco = (e) => {
    let result = onlyNumber(e.target.value);
    setValue("numEndereco", result);
  };

  // Classes de Resíduo
  const [classesResiduo, set_classesResiduo] = useState([]);
  const [optionsClassesResiduo, set_OptionsClassesResiduo] = useState([]);
  const loadOptionsClassesResiduo = (categoria_Id) => {
    api_GET(`ClasseResiduo/GetListAtivosByCategoria/${categoria_Id}`)
      .then((result) => {
        set_OptionsClassesResiduo(result.data);
        if (tipoCadastro == "Protocolo") {
          if (
            item != null &&
            item.protocoloTransportador.length > 0 &&
            item.protocoloTransportador[0]
              .protocoloTransportadorClasseResiduo != null
          ) {
            let _classes = [];
            result.data.map((m) => {
              if (
                item.protocoloTransportador[0].protocoloTransportadorClasseResiduo.filter(
                  (f) => f.classeResiduo_Id == m.classeResiduo_Id
                ).length > 0
              )
                _classes.push(m);
            });
            set_classesResiduo(_classes);
          }
        } else if (tipoCadastro == "Requerimento") {
          if (
            item != null &&
            item.requerimentoTransportador.length > 0 &&
            item.requerimentoTransportador[0]
              .requerimentoTransportadorClasseResiduo != null
          ) {
            let _classes = [];
            result.data.map((m) => {
              if (
                item.requerimentoTransportador[0].requerimentoTransportadorClasseResiduo.filter(
                  (f) => f.classeResiduo_Id == m.classeResiduo_Id
                ).length > 0
              )
                _classes.push(m);
            });
            set_classesResiduo(_classes);
          }
        }
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };
  const handleClassesResiduo = (event) => {
    set_classesResiduo(event);
  };

  // Categoria
  const [categoria, set_categoria] = useState(null);

  // cep
  const handleCEP = (event) => {
    clearErrors("cep");

    if (event.target.value.replace(/[^0-9]/g, "").trim().length < 8) {
      setValue("cep", "");
      showMessage(
        "Aviso",
        "Cep inválido. só é permitido preencher com números",
        "error",
        null
      );
      return;
    }

    GetCEPViaCEP(event.target.value).then((result) => {
      if (
        result.status !== 200 ||
        (result.data.hasOwnProperty("erro") && result.data.erro == true)
      ) {
        showMessage("Aviso", "Cep não localizado", "warning", null);
        setValue("logradouro", "");
        setValue("bairro", "");
        setValue("cidade", "");
        setValue("uf", "");
      } else {
        setValue("logradouro", result.data.logradouro);
        setValue("bairro", result.data.bairro);
        setValue("cidade", result.data.localidade);
        setValue("uf", result.data.uf);
      }
    });
  };

  const loadItemRequerimento = () => {
    if (item != null) {
      set_identificacao(item);
      setValue("email", item.email);
      set_email(item.email);
      setValue("cnpj", item.cpf_Cnpj);
      setValue("cpf", item.cpf_Cnpj);
      setValue("nomeSolicitante", item.nomeSolicitante);
      setValue(
        "responsavel",
        item.requerimentoTransportador != null &&
          item.requerimentoTransportador.length > 0
          ? item.requerimentoTransportador[0].nomeResponsavel
          : item.nomeSolicitante
      );
      set_categoria(item.setupSolicitacaoAcao.setupSolicitacao.categoria);
      loadOptionsClassesResiduo(
        item.setupSolicitacaoAcao.setupSolicitacao.categoria_Id
      );

      if (item.cpf_Cnpj.length == 11) {
        set_tipoTransportador("Pessoa Física / MEI")
      } else {
        set_tipoTransportador(
          item.setupSolicitacaoAcao != null &&
            item.setupSolicitacaoAcao.setupSolicitacao.pessoa === "Física"
            ? "Pessoa Física / MEI"
            : item.setupSolicitacaoAcao.setupSolicitacao.pessoa === "Jurídica - MEI" ? "Pessoa Jurídica / MEI" : "Pessoa Jurídica (Privado)"
        );
      }

      if (
        item.requerimentoTransportador != null &&
        item.requerimentoTransportador.length > 0
      ) {
        setValue("fantasia", item.requerimentoTransportador[0].nome_Fantasia);
        setValue("razaoSocial", item.requerimentoTransportador[0].razaoSocial);
        setValue("ccm", item.requerimentoTransportador[0].ccm);
        setValue("telefone", item.requerimentoTransportador[0].telefone);
        setValue("celular", item.requerimentoTransportador[0].celular);
        setValue("nomeResponsavelTecnico", item.requerimentoTransportador[0]?.nomeResponsavelTecnico ?? "");
        setValue(
          "tipoIndustriaComercio",
          item.requerimentoTransportador[0].tipoIndustriaComercio
        );
        set_tipoIndustria(
          item.requerimentoTransportador[0].tipoIndustriaComercio
        );
        setValue("ramo", item.requerimentoTransportador[0].ramoAtividade);
        set_ramo(item.requerimentoTransportador[0].ramoAtividade);
        setValue(
          "dataFimVigencia",
          item.dataFimVigencia != null
            ? formateDateApi(item.dataFimVigencia)
            : ""
        );
        setValue("cep", item.requerimentoTransportador[0].cep);
        setValue("logradouro", item.requerimentoTransportador[0].logradouro);
        setValue("bairro", item.requerimentoTransportador[0].bairro);
        setValue("numEndereco", item.requerimentoTransportador[0].numEndereco);
        setValue("complemento", item.requerimentoTransportador[0].complemento);
        setValue("cidade", item.requerimentoTransportador[0].cidade);
        setValue("uf", item.requerimentoTransportador[0].uf);
        setValue("status", item.status, true);
        set_status(item.status);
      }
    }
  };

  const loadItemProtocolo = () => {
    if (item != null) {
      set_identificacao(item);
      setValue("email", item.email);
      set_email(item.email);
      setValue("cnpj", item.cpf_Cnpj);
      setValue("cpf", item.cpf_Cnpj);
      setValue("nomeSolicitante", item.nomeSolicitante);
      setValue(
        "responsavel",
        item.protocoloTransportador != null &&
          item.protocoloTransportador.length > 0
          ? item.protocoloTransportador[0].nomeResponsavel
          : item.nomeSolicitante
      );
      set_categoria(
        item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria
      );
      loadOptionsClassesResiduo(
        item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria_Id
      );

      if (item.cpf_Cnpj.length == 11) {
        set_tipoTransportador("Pessoa Física / MEI");
      } else {
        set_tipoTransportador(
          item.setupSolicitacaoAcaoNovoCadastro != null &&
            item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.pessoa ==
            "Física"
            ? "Pessoa Física / MEI"
            : item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.pessoa === "Jurídica - MEI" ? "Pessoa Jurídica / MEI" : "Pessoa Jurídica (Privado)"
        );
      }

      if (item.protocoloTransportador.length > 0) {
        setValue("fantasia", item.protocoloTransportador[0].nome_Fantasia);
        setValue("razaoSocial", item.protocoloTransportador[0].razaoSocial);
        setValue("ccm", item.protocoloTransportador[0].ccm);
        setValue("codigoCadastro", item.codigoCadastro);
        setValue("telefone", item.protocoloTransportador[0].telefone);
        setValue("celular", item.protocoloTransportador[0].celular);
        setValue("nomeResponsavelTecnico", item.protocoloTransportador[0]?.nomeResponsavelTecnico ?? "");
        setValue(
          "tipoIndustriaComercio",
          item.protocoloTransportador[0].tipoIndustriaComercio
        );
        set_tipoIndustria(item.protocoloTransportador[0].tipoIndustriaComercio);
        setValue("ramo", item.protocoloTransportador[0].ramoAtividade);
        set_ramo(item.protocoloTransportador[0].ramoAtividade);
        setValue(
          "dataFimVigencia",
          item.dataFimVigencia != null
            ? formateDateApi(item.dataFimVigencia)
            : ""
        );
        setValue("cep", item.protocoloTransportador[0].cep);
        setValue("logradouro", item.protocoloTransportador[0].logradouro);
        setValue("bairro", item.protocoloTransportador[0].bairro);
        setValue("numEndereco", item.protocoloTransportador[0].numEndereco);
        setValue("complemento", item.protocoloTransportador[0].complemento);
        setValue("cidade", item.protocoloTransportador[0].cidade);
        setValue("uf", item.protocoloTransportador[0].uf);
        setValue("status", item.status, true);
        set_status(item.status);
      }
    }
  };

  const loadDefaultValues = (field) => {
    if (item == null) return "";

    if (tipoCadastro == "Protocolo") {
      switch (field) {
        case "Telefone":
          return item.protocoloTransportador.length > 0
            ? item.protocoloTransportador[0].telefone
            : "";
        case "Celular":
          return item.protocoloTransportador.length > 0
            ? item.protocoloTransportador[0].celular
            : "";
        case "CEP":
          return item.protocoloTransportador.length > 0
            ? item.protocoloTransportador[0].cep
            : "";
      }
    } else if (tipoCadastro == "Requerimento") {
      if (item.requerimentoTransportador != null) {
        switch (field) {
          case "Telefone":
            return item.requerimentoTransportador.length > 0
              ? item.requerimentoTransportador[0].telefone
              : "";
          case "Celular":
            return item.requerimentoTransportador.length > 0
              ? item.requerimentoTransportador[0].celular
              : "";
          case "CEP":
            return item.requerimentoTransportador.length > 0
              ? item.requerimentoTransportador[0].cep
              : "";
        }
      }
    }
  };

  useEffect(() => {
    if (session != null && session.tipoAcesso == "AreaRestrita")
      set_permiteEditar(true);
    loadOptionsSubPrefeitura();
    if (tipoCadastro == "Protocolo") loadItemProtocolo();
    else if (tipoCadastro == "Requerimento") loadItemRequerimento();
  }, []);

  const onSubmit = (data) => {
    setLoading(true);

    if (email == null || email.length == 0) {
      setLoading(false);
      showMessage("Aviso", "E-Mail não informado", "error", null);
      return;
    }

    if (isValidDate(data.dataFimVigencia) == false) {
      setLoading(false);
      showMessage("Aviso", "Data de validade inválida.", "warning", null);
      return;
    }

    let numeroEndereco = onlyNumber(data.numEndereco);
    if (numeroEndereco.length == "") {
      setLoading(false);
      showMessage(
        "Aviso",
        "Número de endereço inválido, ou, não informado. Só é permitido o preenchimento de dígitos numéricos.",
        "warning",
        null
      );
      return;
    }

    if (permiteManutencao && tipoCadastro == "Protocolo") {
      let json = carregaJsonProtocolo(data);
      EnviaProtocoloWithProtocoloTransportador(json, handleRetornoSubmit);
    } else if (tipoCadastro == "Requerimento") {
      let json = carregaJsonRequerimento(data);
      EnviaRequerimentoTransportador(json, handleRetornoSubmit);
    } else {
      set_identificacao(item);
      handleProximoStep(item);
    }
  };

  const carregaJsonRequerimento = (data) => {
    let requerimentoTransportadorClasseResiduo = [];
    classesResiduo.map((m) => {
      requerimentoTransportadorClasseResiduo.push({
        requerimentoTransportadorClasseResiduo_Id: 0,
        requerimento_Id: item != null ? item.requerimento_Id : 0,
        classeResiduo_Id: m.classeResiduo_Id,
      });
    });

    let json_submit = {
      requerimentoTransportador_Id:
        item != null &&
          item.requerimentoTransportador != null &&
          item.requerimentoTransportador.length > 0
          ? item.requerimentoTransportador[0].requerimentoTransportador_Id
          : 0,
      requerimento_Id: item != null ? item.requerimento_Id : 0,
      subPrefeitura_Id: subPrefeitura.subPrefeitura_Id,
      cpf_Cnpj:
        data.cnpj != null
          ? data.cnpj.replace(/[./-]/g, "")
          : data.cpf.replace(/[./-]/g, ""),
      nome_Fantasia: data.fantasia == null ? data.responsavel : data.fantasia,
      razaoSocial:
        data.razaoSocial == null ? data.responsavel : data.razaoSocial,
      nomeResponsavel: data.responsavel,
      nomeResponsavelTecnico: data?.nomeResponsavelTecnico ?? "",
      nomeSolicitante:
        data.nomeSolicitante == null ? data.responsavel : data.nomeSolicitante,
      cCM: data.ccm,
      cEP: data.cep.replace(/[^0-9]/g, ""),
      logradouro: data.logradouro,
      numEndereco: data.numEndereco,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uF: data.uf,
      telefone: data.telefone
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll("-", "")
        .replaceAll(" ", ""),
      celular: data.celular
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll("-", "")
        .replaceAll(" ", ""),
      ramoAtividade: data.ramo,
      tipoIndustriaComercio: data.tipoIndustriaComercio,
      requerimentoTransportadorClasseResiduo:
        requerimentoTransportadorClasseResiduo,
    };

    return json_submit;
  };

  const carregaJsonProtocolo = (data) => {
    let protocoloTransportadorClasseResiduo = [];
    classesResiduo.map((m) => {
      protocoloTransportadorClasseResiduo.push({
        protocoloTransportadorClasseResiduo_Id: 0,
        protocolo_Id: item != null ? item.protocolo_Id : 0,
        classeResiduo_Id: m.classeResiduo_Id,
      });
    });

    let json_submit = {
      protocolo_Id: item != null ? item.protocolo_Id : 0,
      numeroProtocolo: item != null ? item.numeroProtocolo : "",
      nomeSolicitante:
        data.nomeSolicitante == null ? data.responsavel : data.nomeSolicitante,
      email: data.email,
      cpf_Cnpj:
        data.cnpj != null
          ? data.cnpj.replace(/[./-]/g, "")
          : data.cpf.replace(/[./-]/g, ""),
      status: item != null && status == "" ? item.status : status,
      dataFimVigencia:
        session != null && session.tipoAcesso == "AreaRestrita"
          ? data.dataFimVigencia
          : item.dataFimVigencia,
      usuarioCadastro_Id:
        session != null && session.tipoAcesso == "AreaRestrita"
          ? session.usuario_Id
          : null,
      usuarioUltimaAlteracao_Id:
        session != null && session.tipoAcesso == "AreaRestrita"
          ? session.usuario_Id
          : null,
      etapaCadastro: 1,
      codigoCadastro: data.codigoCadastro,
      protocoloTransportador: [
        {
          protocoloTransportador_Id:
            item != null && item.protocoloTransportador.length > 0
              ? item.protocoloTransportador[0].protocoloTransportador_Id
              : 0,
          protocolo_Id: item != null ? item.protocolo_Id : 0,
          subPrefeitura_Id: subPrefeitura.subPrefeitura_Id,
          cpf_Cnpj:
            data.cnpj != null
              ? data.cnpj.replace(/[./-]/g, "")
              : data.cpf.replace(/[./-]/g, ""),
          nome_Fantasia:
            data.fantasia == null ? data.responsavel : data.fantasia,
          razaoSocial:
            data.razaoSocial == null ? data.responsavel : data.razaoSocial,
          nomeResponsavel: data.responsavel,
          nomeResponsavelTecnico: data?.nomeResponsavelTecnico ?? "",
          cCM: data.ccm,
          codigoCadastro:
            item != null && item.protocoloTransportador.length > 0
              ? item.codigoCadastro
              : "0",
          cEP: data.cep.replace(/[^0-9]/g, ""),
          logradouro: data.logradouro,
          numEndereco: data.numEndereco,
          complemento: data.complemento,
          bairro: data.bairro,
          cidade: data.cidade,
          uF: data.uf,
          telefone: data.telefone
            .replaceAll("(", "")
            .replaceAll(")", "")
            .replaceAll("-", "")
            .replaceAll(" ", ""),
          celular: data.celular
            .replaceAll("(", "")
            .replaceAll(")", "")
            .replaceAll("-", "")
            .replaceAll(" ", ""),
          ramoAtividade: data.ramo,
          tipoIndustriaComercio: data.tipoIndustriaComercio,
          protocoloTransportadorClasseResiduo:
            protocoloTransportadorClasseResiduo,
        },
      ],
      protocoloJustificativas: [
        {
          protocoloJustificativas_Id:
            item != null &&
              item.protocoloJustificativas != null &&
              item.protocoloJustificativas.length > 0
              ? item.protocoloJustificativas[0].protocoloJustificativas_Id
              : 0,
          protocolo_Id: item != null ? item.protocolo_Id : 0,
          UsuarioJustificativa:
            session != null && session.tipoAcesso == "AreaRestrita"
              ? session.usuario_Id
              : null,
          observacao: data.observacao,
          usuario: data.usuario,
        },
      ],
    };
    return json_submit;
  };

  const handleRetornoSubmit = (result) => {
    setLoading(false);
    set_identificacao(result.data);
    handleProximoStep(result.data);
  };

  function loadValueTipoPessoa() {
    return !!tipoTransportador ?
      optionsTipoTransportador.filter((obj) => obj.value == tipoTransportador)[0] :
      optionsTipoTransportador[2];
  }

  return (
    <>
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          Histórico de Justificativas.
        </ModalHeader>
        <ModalBody>
          <Form>
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col" className="">
                      Data da Justificativa
                    </th>
                    <th scope="col">Observação</th>
                    <th scope="col">Usuário</th>
                  </tr>
                </thead>
                <tbody>
                  {item.protocoloJustificativas != undefined &&
                    item.protocoloJustificativas.length > 0 &&
                    item.protocoloJustificativas.map((justificativa) => (
                      <tr>
                        <td>
                          {formateDateandTime(justificativa.dataJustificativa)}
                        </td>
                        <td>{justificativa.observacao}</td>
                        <td>
                          {justificativa.usuario == undefined ||
                            justificativa.usuario == null
                            ? justificativa.usuarioJustificativa
                            : justificativa.usuario.nome}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            OK
          </Button>
        </ModalFooter>
      </Modal>
      <div>
        <Card className={`card card-stats`}>
          <CardHeader>
            <Row>
              <Col md="12" className="text-right">
                <label className="text-danger">* Campos Obrigatórios</label>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <h2 className="titulo-solicitacao">Identificação </h2>
              <h6 style={{ padding: 0, margin: 0 }} className="text-center">
                {categoria && categoria.descricao}
              </h6>
              <Container style={{ maxWidth: "1000px", margin: "0px auto" }}>
                <Row>
                  <Col md="12">
                    <div className="formPrincipal">
                      <h4
                        style={{
                          borderBottom: "solid 1px #ccc",
                          width: "100%",
                        }}
                      >
                        Dados de Identificação
                      </h4>
                      <Row>
                        <Col md="3" lg="4">
                          <FormGroup>
                            <b>
                              <label>Tipo Pessoa</label>{" "}
                            </b>
                            <Select
                              options={optionsTipoTransportador}
                              name="tipoTransportador"
                              value={loadValueTipoPessoa()}
                              onChange={(value) => handleTipoTransportador(value)}
                              placeholder="Selecione"
                              ref={(e) =>
                                register(
                                  { name: "tipoTransportador" },
                                  { required: false }
                                )
                              }
                              isDisabled={identificacao != null ? true : false}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <b>
                              <label>
                                <span className="text-danger">* </span> Nome
                                Responsável
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="responsavel"
                              innerRef={register({ required: permiteEditar })}
                              maxLength="50"
                              autoComplete="off"
                            />
                            {errors.responsavel && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        {categoria &&
                          categoria.sigla == "RGG" && (
                            <Col md="4">
                              <FormGroup>
                                <b>
                                  <label>
                                    Nome Responsável Técnico (CREA)
                                  </label>
                                </b>
                                <Input
                                  type="text"
                                  name="nomeResponsavelTecnico"
                                  innerRef={register({ required: permiteEditar })}
                                  maxLength="100"
                                  autoComplete="off"
                                />
                                {errors.nomeResponsavelTecnico && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        <Col md="4">
                          <FormGroup>
                            <b>
                              <label>
                                <span className="text-danger">* </span>Email
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="email"
                              onBlur={handleEmail}
                              innerRef={register({ required: permiteEditar })}
                              maxLength="200"
                              autoComplete="off"
                            />
                            {errors.email && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        {(tipoTransportador == "Pessoa Jurídica (Privado)" ||
                          tipoTransportador === "Pessoa Jurídica / MEI" ||
                          tipoTransportador == "Pessoa Jurídica (Público)") && (
                            <Col md="5">
                              <FormGroup>
                                <b>
                                  <label>
                                    <span className="text-danger">*</span> Nome
                                    Fantasia{" "}
                                    <a href="#" id="questionNomeFantasia">
                                      <i className="fas fa-question-circle"></i>
                                    </a>
                                    <UncontrolledTooltip
                                      target="questionNomeFantasia"
                                      placement="top"
                                    >
                                      Caso a empresa não tenha Nome Fantasia,
                                      informe a Razão Social
                                    </UncontrolledTooltip>
                                  </label>
                                </b>
                                <Input
                                  type="text"
                                  name="fantasia"
                                  id="fantasia"
                                  onKeyUp={handleFantasia}
                                  innerRef={register({ required: true })}
                                  maxLength="100"
                                  autoComplete="off"
                                />
                                {errors.fantasia && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        {(tipoTransportador == "Pessoa Jurídica (Privado)" ||
                          tipoTransportador === "Pessoa Jurídica / MEI" ||
                          tipoTransportador == "Pessoa Jurídica (Público)") && (
                            <Col md="6">
                              <FormGroup>
                                <b>
                                  <label>
                                    <span className="text-danger">*</span> Razão
                                    Social{" "}
                                  </label>
                                </b>
                                <Input
                                  type="text"
                                  name="razaoSocial"
                                  id="razaoSocial"
                                  onBlur={handleRazaoSocial}
                                  innerRef={register({ required: true })}
                                  maxLength="100"
                                  autoComplete="off"
                                />
                                {errors.razaoSocial && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        <Col md="12">
                          <FormGroup>
                            <b>
                              <span className="text-danger">* </span>
                              <label>
                                {tipoTransportador == "Pessoa Física / MEI"
                                  ? "Nome/Razão Social"
                                  : "Nome Solicitante"}{" "}
                                <a href="#" id="questionNomeSolicitante">
                                  <i className="fas fa-question-circle"></i>
                                </a>
                                <UncontrolledTooltip
                                  target="questionNomeSolicitante"
                                  placement="top"
                                >
                                  Nome que aparecerá na tela inicial.
                                </UncontrolledTooltip>
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="nomeSolicitante"
                              id="nomeSolicitante"
                              onKeyUp={handleSolicitante}
                              innerRef={register({ required: true })}
                              maxLength="50"
                              autoComplete="off"
                            />
                            {errors.nomeSolicitante && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        {(tipoTransportador == "Pessoa Jurídica (Privado)" ||
                          tipoTransportador == "Pessoa Jurídica / MEI" ||
                          tipoTransportador == "Pessoa Jurídica (Público)" ||
                          (tipoTransportador == "Pessoa Física / MEI" &&
                            item != null &&
                            item?.cpf_Cnpj.length == 14)) && (
                            <Col md="3">
                              <FormGroup>
                                <b>
                                  <label>
                                    <span className="text-danger">*</span> CNPJ
                                  </label>
                                </b>
                                <InputCNPJ
                                  name="cnpj"
                                  defaultValue={item != null && item.cpf_Cnpj}
                                  inputRef={register({ required: permiteEditar })}
                                  readOnly={identificacao != null ? true : false}
                                  autoComplete="off"
                                />
                                {errors.cnpj && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        {tipoTransportador == "Pessoa Física / MEI" &&
                          item != null &&
                          item?.cpf_Cnpj.length == 11 && (
                            <Col md="3">
                              <FormGroup>
                                <b>
                                  <label>
                                    <span className="text-danger">*</span> CPF
                                  </label>
                                </b>
                                <InputCPF
                                  name="cpf"
                                  defaultValue={item != null && item.cpf_Cnpj}
                                  inputRef={register({
                                    required: permiteEditar,
                                  })}
                                  readOnly={
                                    identificacao != null ? true : false
                                  }
                                  autoComplete="off"
                                />
                                {errors.cpf && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        <Col md="3">
                          <FormGroup>
                            <b>
                              <label>
                                CCM{" "}
                                <a href="#" id="questionCCM">
                                  <i className="fas fa-question-circle"></i>
                                </a>
                                <UncontrolledTooltip
                                  target="questionCCM"
                                  placement="top"
                                >
                                  Cadastro de Contribuintes Mobiliários (Se seu
                                  município não tiver essa informação, deixe o
                                  campo em branco)
                                </UncontrolledTooltip>
                              </label>
                            </b>
                            <Input
                              type="text"
                              name="ccm"
                              innerRef={register({ required: false })}
                              maxLength="10"
                              autoComplete="off"
                              onChange={(event) =>
                                setValue(
                                  "ccm",
                                  event.target.value.replace(/\D/g, "")
                                )
                              }
                            />
                          </FormGroup>
                        </Col>
                        {session != null &&
                          session.tipoAcesso == "AreaRestrita" &&
                          session.usuario_Id != null && (
                            <Col md="3">
                              <FormGroup>
                                <b>
                                  <label>Número Cadastro</label>
                                </b>
                                <Input
                                  type="text"
                                  name="codigoCadastro"
                                  innerRef={register({ required: true })}
                                  maxLength="10"
                                />
                                {errors.codigoCadastro && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        <Col md="3">
                          <FormGroup>
                            <b>
                              <span className="text-danger">* </span>
                              <label>Telefone</label>
                            </b>
                            <InputTELEFONE
                              type="text"
                              name="telefone"
                              defaultValue={loadDefaultValues("Telefone")}
                              inputRef={register({ required: permiteEditar })}
                            />
                            {errors.telefone && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md="3">
                          <FormGroup>
                            <b>
                              <label>Celular</label>
                            </b>
                            <InputTELEFONE
                              type="text"
                              name="celular"
                              defaultValue={loadDefaultValues("Celular")}
                              inputRef={register({ required: false })}
                            />
                          </FormGroup>
                        </Col>
                        {(tipoTransportador == "Pessoa Jurídica (Privado)" ||
                          tipoTransportador === "Pessoa Jurídica / MEI" ||
                          tipoTransportador == "Pessoa Jurídica (Público)") && (
                            <Col md="4">
                              <FormGroup>
                                <b>
                                  <label>Tipo Indústria/Comércio</label>
                                </b>
                                <Input
                                  type="text"
                                  name="tipoIndustriaComercio"
                                  innerRef={register({ required: false })}
                                  maxLength="100"
                                  readOnly={
                                    tipoIndustria != null &&
                                      tipoIndustria.length != 0
                                      ? "readonly"
                                      : false
                                  }
                                />
                                {errors.tipoIndustriaComercio && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        {(tipoTransportador === "Pessoa Jurídica (Privado)" ||
                          tipoTransportador === "Pessoa Jurídica / MEI" ||
                          tipoTransportador === "Pessoa Jurídica (Público)") &&
                          categoria &&
                          categoria.sigla != "RGG" && (
                            <Col md="5">
                              <FormGroup>
                                <b>
                                  <label>Ramo</label>
                                </b>
                                <Input
                                  type="text"
                                  name="ramo"
                                  innerRef={register({ required: false })}
                                  defaultValue={ramo}
                                  maxLength="100"
                                  readOnly={
                                    ramo != null && ramo.length != 0
                                      ? "readonly"
                                      : false
                                  }
                                />
                                {errors.ramo && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        {session != null &&
                          session.tipoAcesso == "AreaRestrita" &&
                          session.usuario_Id != null && (
                            <Col md="3">
                              <FormGroup>
                                <b>
                                  <label>Validade</label>
                                </b>
                                <Input
                                  type="date"
                                  name="dataFimVigencia"
                                  innerRef={register({ required: true })}
                                  onBlur={handleDataVigencia}
                                />
                                {errors.dataFimVigencia && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                        <Col
                          md="9"
                          lg="9"
                          className={
                            optionsClassesResiduo.length > 0 ? "" : "d-none"
                          }
                        >
                          <FormGroup>
                            <b>
                              <label>Classes de Resíduo</label>{" "}
                            </b>
                            <Select
                              options={optionsClassesResiduo}
                              getOptionLabel={({ descricao }) => descricao}
                              getOptionValue={({ classeResiduo_Id }) =>
                                classeResiduo_Id
                              }
                              name="classeResiduo"
                              isMulti={true}
                              value={optionsClassesResiduo.filter(
                                ({ classeResiduo_Id }) =>
                                  classesResiduo.filter(
                                    (f) =>
                                      f.classeResiduo_Id == classeResiduo_Id
                                  ).length > 0
                              )}
                              onChange={(value) =>
                                handleClassesResiduo(value || [])
                              }
                              placeholder="Selecione"
                              ref={(e) =>
                                register(
                                  { name: "classeResiduo" },
                                  { required: false }
                                )
                              }
                              isDisabled={!permiteEditar}
                            />
                          </FormGroup>
                        </Col>
                        {session != null &&
                          session.tipoAcesso == "AreaRestrita" &&
                          session.usuario_Id != null && (
                            <Col md="3">
                              <FormGroup>
                                <b>
                                  <label>Status</label>
                                </b>
                                <Select
                                  options={options_status}
                                  name="status"
                                  onChange={(e) => {
                                    handleStatus(e.value);
                                  }}
                                  getOptionLabel={({ label }) => label}
                                  getOptionValue={({ value }) => value}
                                  value={
                                    status != "" &&
                                    options_status.find(
                                      (obj) => obj.value === status
                                    )
                                  }
                                  placeholder="Selecione"
                                  ref={(e) =>
                                    register(
                                      { name: "status" },
                                      { required: permiteEditar }
                                    )
                                  }
                                  isDisabled={
                                    !permiteEditar || status == "Irregular"
                                  }
                                />
                                {errors.status && (
                                  <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                  </span>
                                )}
                              </FormGroup>
                            </Col>
                          )}
                      </Row>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="formPrincipal">
                      <h4
                        style={{
                          borderBottom: "solid 1px #ccc",
                          width: "100%",
                        }}
                      >
                        Endereço
                      </h4>
                      <Form>
                        <Row>
                          <Col md="3" lg="3">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span> CEP
                                </label>
                              </b>
                              <InputCEP
                                name="cep"
                                defaultValue={loadDefaultValues("CEP")}
                                onBlur={handleCEP}
                                inputRef={register({ required: permiteEditar })}
                              />
                              {errors.cep && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="5" lg="5">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span>
                                  Logradouro
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="logradouro"
                                maxLength="100"
                                innerRef={register({ required: true })}
                              />
                              {errors.logradouro && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="4" lg="4">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span>Bairro
                                </label>
                              </b>
                              <Input
                                type="text"
                                name="bairro"
                                innerRef={register({ required: permiteEditar })}
                                maxLength="50"
                              />
                              {errors.bairro && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="2" lg="2">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span> Número
                                </label>
                              </b>
                              <Input
                                type="number"
                                name="numEndereco"
                                innerRef={register({ required: permiteEditar })}
                                onChange={handleNumeroEndereco}
                              />
                              {errors.numEndereco && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="3" lg="3">
                            <FormGroup>
                              <b>
                                <label>Complemento</label>
                              </b>
                              <Input
                                type="text"
                                name="complemento"
                                innerRef={register({ required: false })}
                                maxLength="50"
                              />
                            </FormGroup>
                          </Col>
                          <Col md="5" lg="5">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span> Cidade
                                </label>
                              </b>
                              <Input
                                type="text"
                                readOnly="readonly"
                                name="cidade"
                                innerRef={register({ required: permiteEditar })}
                                maxLength="50"
                              />
                              {errors.cidade && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="2" lg="2">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span> UF
                                </label>
                              </b>
                              <Input
                                type="text"
                                readOnly="readonly"
                                name="uf"
                                innerRef={register({ required: permiteEditar })}
                                maxLength="2"
                              />
                              {errors.uf && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="6" lg="6">
                            <FormGroup>
                              <b>
                                <label>
                                  <span className="text-danger">*</span>{" "}
                                  Regional / SubPrefeitura
                                </label>{" "}
                              </b>
                              <Select
                                options={optionsSubPrefeitura}
                                getOptionLabel={(option) => option.nome}
                                getOptionValue={(option) =>
                                  option.subPrefeitura_Id
                                }
                                name="subPrefeitura"
                                onChange={(e) => {
                                  handleSubPrefeitura(e);
                                }}
                                value={subPrefeitura}
                                placeholder="Selecione"
                                ref={(e) =>
                                  register(
                                    { name: "subPrefeitura" },
                                    {
                                      required:
                                        subPrefeitura != null &&
                                          subPrefeitura != 0
                                          ? false
                                          : true,
                                    }
                                  )
                                }
                                isDisabled={!permiteEditar}
                              />
                              {errors.subPrefeitura && (
                                <span className="form-control-label text-danger">
                                  * Campo Obrigatório
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md="12">
                            <FormGroup>
                              <b>
                                <label>Observação</label>
                              </b>
                              <Input
                                type="textarea"
                                name="observacao"
                                innerRef={register({ required: false })}
                                maxLength="8000"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </Col>
                  <Col md="4">
                    {session != null &&
                      session.tipoAcesso == "AreaRestrita" &&
                      session.usuario_Id != null && (
                        <Button
                          color="secundary"
                          onClick={handleReturn}
                          className="btn-mobile"
                          type="submit"
                        >
                          <i className="fas fa-chevron-left"></i> Voltar
                        </Button>
                      )}
                  </Col>
                  <Col md="4">
                    {session != null &&
                      session.tipoAcesso == "AreaRestrita" &&
                      session.usuario_Id != null &&
                      item.protocoloJustificativas.length > 0 && (
                        <Button
                          color="info"
                          onClick={toggleModal}
                          className="btn-mobile"
                          type="button"
                        >
                          <i className="fas fa-info"></i> Justificativas
                        </Button>
                      )}
                  </Col>
                  <Col md="4" className="text-right">
                    <Button
                      color="success"
                      className="btn-mobile"
                      type="submit"
                    >
                      Próxima Etapa <i className="fas fa-chevron-right"></i>
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Form>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
